import { SourcingSharedSetupApplicationFormData } from 'modules/sourcing-shared/forms';
import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { scrollToTop } from 'common/utils';

type HandleSourcingSharedSetupApplicationNextControllerProps = {
  applicationFormData: SourcingSharedSetupApplicationFormData;
  get: SharedSourcingStoreApi['getState'];
  set: SharedSourcingStoreApi['setState'];
};

export const handleSourcingSharedSetupApplicationNextController = ({
  applicationFormData,
  get,
  set
}: HandleSourcingSharedSetupApplicationNextControllerProps) => {
  scrollToTop();

  const { applicationFormData: previousApplicationFormData } = get();

  // Clear customizeMessageFormData when campaign type changes
  // to force regeneration of the message with the correct ending
  const shouldClearCustomizeMessage =
    previousApplicationFormData &&
    previousApplicationFormData.campaignType !==
      applicationFormData.campaignType;

  set({
    step: 'CUSTOMIZE_MESSAGE',
    applicationFormData,
    ...(shouldClearCustomizeMessage && { customizeMessageFormData: null })
  });
};
